import { render, staticRenderFns } from "./youtube.vue?vue&type=template&id=a37fedd0&"
import script from "./youtube.vue?vue&type=script&lang=js&"
export * from "./youtube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Projekte/woerner-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a37fedd0')) {
      api.createRecord('a37fedd0', component.options)
    } else {
      api.reload('a37fedd0', component.options)
    }
    module.hot.accept("./youtube.vue?vue&type=template&id=a37fedd0&", function () {
      api.rerender('a37fedd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/woerner/pages/youtube.vue"
export default component.exports